import calculateRemainingDays from 'root/services/calculate-remaining-days';

Ctrl.$inject = ['$scope', '$element'];
export default function Ctrl($scope, $element) {
  const vm = this;

  Object.assign(vm, {
    $onInit() {
      $element[0].focus();
    },

    $onChanges(changes){
      if(changes.dueDate) {
        vm.days = calculateRemainingDays(vm.dueDate);
      }
    },

    hide (action) {
      if(action) {
        action();
        vm.nagClass = 'nagClosed';
      } else {
        vm.nagClass = 'nagClosing';
        closeNagElementToButton();
        $scope.$applyAsync();
        $scope.$timeout( () => { vm.nagClass = 'nagClosed' }, 500);
      }
    }
  });

  function closeNagElementToButton() {
    const
      el = $element[0],
      window = el.querySelector('div.rbPublicBidNag'),
      button = el.querySelector('#CONTINUE'),
      buttonRect = button.getBoundingClientRect(),
      windowRect = window.getBoundingClientRect(),
      xDelta = (buttonRect.left + buttonRect.right - windowRect.left - windowRect.right)/2,
      yDelta = (buttonRect.top + buttonRect.bottom - windowRect.top - windowRect.bottom)/2,
      xScale = buttonRect.width/windowRect.width,
      yScale = buttonRect.height/windowRect.height;

    window.setAttribute('style', `transform: translate(${xDelta}px, ${yDelta}px) scale(${xScale}, ${yScale}); opacity: .1`);
  }
}
